import { DerivedEventTypeLegacy, type SubjectVariableLegacy } from '@verantos-dev/types-cohorts';

import { transformDerivedEventTypeToGrammarValue } from '../adapters/transformDerivedEventTypeToGrammarValue';

export const getNextSubjectVariablesForDerivedEventNameChange = (
  subjectVariables: SubjectVariableLegacy[],
  referencedEventName: string,
  newReferencedEventName: string,
  newType: DerivedEventTypeLegacy | undefined
) => {
  return subjectVariables.map((subjectVariable) => {
    if (subjectVariable.countFilter) {
      return {
        ...subjectVariable,
        countFilter: {
          ...subjectVariable.countFilter,
          inputFields: subjectVariable.countFilter.inputFields.map((inputField, index) => {
            const countReferenceEventName = inputField.value?.split('::')[1];
            if (
              index === 0 &&
              countReferenceEventName?.slice(1, countReferenceEventName.length - 1) ===
                referencedEventName
            ) {
              return {
                ...inputField,
                value: `${transformDerivedEventTypeToGrammarValue(
                  newType
                )}::"${newReferencedEventName}"`,
              };
            }
            return inputField;
          }),
        },
      };
    }
    return subjectVariable;
  });
};
